import Stat from "@web-ui/components/Stat";
import type { Definition } from "../definitions";
import type { Change } from "../format";
import { Sparkline } from "../charts/sparkline";
import { ChangeNote } from "./change-note";
import { MetricLabel } from "./metric-label";

/**
 * One KPI tile (the kit's Stat): the metric's name with its meaning, the figure, the change
 * against the previous period and, when there is a daily series, its sparkline.
 */
export function MetricTile({ definition, value, change, upIsGood, trend, trendPartial }: {
  definition: Definition;
  value: string;
  change?: Change;
  upIsGood?: boolean;
  /** One value per day of the range, aligned with the other tiles of the row. */
  trend?: ReadonlyArray<number | null>;
  /** The trend's last day is today, still going. */
  trendPartial?: boolean;
}) {
  const note = change || trend ? (
    <span className="flex flex-col gap-2">
      {change ? <ChangeNote change={change} upIsGood={upIsGood} /> : null}
      {trend ? <Sparkline values={trend} partialLast={trendPartial} /> : null}
    </span>
  ) : undefined;
  return <Stat className="h-full" label={<MetricLabel definition={definition} />} value={value} note={note} />;
}
